import { CommonProps } from '@accedo/one-plugin-sdk';
import { ComponentType, PropsWithChildren } from 'react';

import { HttpHeader } from '#/service/constants';
import { getDeviceInfo } from '#/service/user/userSessionManager';
import { tb } from '#/store/translation/translation.store';

/** HOC to pass the CommonProps automatically to the plugin components. */
export function withCommonProps<TProps>(
  Comp: ComponentType<PropsWithChildren<TProps & CommonProps>>,
  config: object
) {
  const WrapperComp = (props: TProps) => (
    <Comp
      {...props}
      config={config}
      defaultHeaders={{
        [HttpHeader.DeviceInfo]: JSON.stringify(getDeviceInfo()),
      }}
      platform="web"
      translate={tb}
    />
  );

  // Comp.name is an empty string for unnamed components, hence the `||`
  const compDisplayName = Comp.displayName ?? (Comp.name || 'Component');
  WrapperComp.displayName = `withConfig(${compDisplayName})`;

  return WrapperComp;
}
